import { render, staticRenderFns } from "./productSearch.vue?vue&type=template&id=55b62240&scoped=true"
import script from "./productSearch.vue?vue&type=script&lang=js"
export * from "./productSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b62240",
  null
  
)

export default component.exports